import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getPortalToken = () => localStorage.getItem("fabriko_portal_token");
export const setPortalToken = (t) => {
  if (t) localStorage.setItem("fabriko_portal_token", t);
  else localStorage.removeItem("fabriko_portal_token");
};

const portalApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((config) => {
  const t = getPortalToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const portalMediaSrc = (url) => `${BACKEND_URL}${url}?auth=${getPortalToken()}`;

export default portalApi;
